import { useMemo } from 'react';
import { useFeatureFlag } from 'modules/common/hooks/useFeatureFlag';
import {
  isSuggestion as isLabelASuggestion,
  useIsSmartSuggestionSettingEnabled
} from '../../timesheet-labels/hooks';
import { LabelValueSource } from '../../../graphql/types';
import {
  CustomLabel,
  TimesheetLabel
} from '../../timesheet-labels/labelSchema';

export const useIsSuggestion = (
  label: TimesheetLabel | CustomLabel | null | undefined
): boolean => {
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();
  const isLabelLevelAcceptedByEnabled = useFeatureFlag(
    'isLabelLevelAcceptedByEnabled',
    false
  );
  const isTimeSignalFederatedSuggestionsEnabled = useFeatureFlag(
    'isTimeSignalFederatedSuggestionsEnabled',
    false
  );

  return useMemo(() => {
    if (!label) return false;
    if (
      isLabelLevelAcceptedByEnabled ||
      isTimeSignalFederatedSuggestionsEnabled
    ) {
      return isLabelASuggestion(
        isSmartSuggestionEnabled,
        isTimeSignalFederatedSuggestionsEnabled,
        label
      );
    }
    return (
      isSmartSuggestionEnabled &&
      (Boolean(label?.value?.stringValue) ||
        Boolean(label?.value?.numericValue)) &&
      label?.valueSource === LabelValueSource.Suggestion
    );
  }, [
    isLabelLevelAcceptedByEnabled,
    isSmartSuggestionEnabled,
    isTimeSignalFederatedSuggestionsEnabled,
    label
  ]);
};
